import * as React from 'react';
import type { SVGProps } from 'react';

/**
 * Contabile brand mark: a ledger frame with three ascending bars.
 * Replaces the upstream Actual logo in this fork.
 */
export const SvgLogo = (props: SVGProps<SVGSVGElement>) => (
  <svg
    {...props}
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 32 32"
    style={{
      color: 'inherit',
      ...props.style,
    }}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M9.5 1.5h13a8 8 0 0 1 8 8v13a8 8 0 0 1-8 8h-13a8 8 0 0 1-8-8v-13a8 8 0 0 1 8-8m0 3.2a4.8 4.8 0 0 0-4.8 4.8v13a4.8 4.8 0 0 0 4.8 4.8h13a4.8 4.8 0 0 0 4.8-4.8v-13a4.8 4.8 0 0 0-4.8-4.8z"
      clipRule="evenodd"
    />
    <path
      fill="currentColor"
      d="M10.4 17.6c.88 0 1.6.72 1.6 1.6v4.2a1.6 1.6 0 1 1-3.2 0v-4.2c0-.88.72-1.6 1.6-1.6M16 13.1c.88 0 1.6.72 1.6 1.6v8.7a1.6 1.6 0 1 1-3.2 0v-8.7c0-.88.72-1.6 1.6-1.6M21.6 8.3c.88 0 1.6.72 1.6 1.6v13.5a1.6 1.6 0 1 1-3.2 0V9.9c0-.88.72-1.6 1.6-1.6"
    />
  </svg>
);
